let getCallbacks = () => null;
let openAddNodeAtRoot = () => {};
let openNode = () => {};
let requestDeleteNode = () => {};
let setSuppressNextRowClick = () => {};

let swipeState = null;
let longPressTimer = null;
let longPressFired = false;

const SWIPE_DELETE_THRESHOLD = 90;
const SWIPE_MAX_OFFSET = 120;
const LONG_PRESS_MS = 500;
const LONG_PRESS_MOVE_THRESHOLD = 10;

export function configureOutlineTouch(deps) {
  getCallbacks = deps.getCallbacks || getCallbacks;
  openAddNodeAtRoot = deps.openAddNodeAtRoot || openAddNodeAtRoot;
  openNode = deps.openNode || openNode;
  requestDeleteNode = deps.requestDeleteNode || requestDeleteNode;
  setSuppressNextRowClick = deps.setSuppressNextRowClick || setSuppressNextRowClick;
}

export function handleSwipeStart(event) {
  if (event.touches.length !== 1) return;
  // Long-press the FAB to add at root.
  const fab = event.target.closest?.("[data-mobile-longpress-action]");
  if (fab && fab.dataset.mobileLongpressAction) {
    clearTimeout(longPressTimer);
    longPressFired = false;
    longPressTimer = setTimeout(() => {
      longPressFired = true;
      const action = fab.dataset.mobileLongpressAction;
      if (action === "add-node-to-root") openAddNodeAtRoot();
      try { navigator.vibrate?.(15); } catch (e) {}
      setSuppressNextRowClick(true);
    }, LONG_PRESS_MS);
    return;
  }
  const row = event.target.closest?.(".mobile-outline-row");
  if (!row) return;
  const nodeId = row.dataset.nodeId;
  if (!nodeId) return;
  // Don't initiate swipe/long-press if touch lands on an interactive child.
  if (event.target.closest?.("button, input, textarea, [data-mobile-rename-input]")) return;
  const touch = event.touches[0];
  const isRoot = row.classList.contains("root");
  // Swiping deletes: allowed on a full map too, to make room.
  const readOnly = getCallbacks()?.Store.isDeleteBlocked?.();
  swipeState = {
    nodeId,
    row,
    startX: touch.clientX,
    startY: touch.clientY,
    deltaX: 0,
    locked: false,
    cancelled: false,
    swipeAllowed: !isRoot && !readOnly,
  };
  longPressFired = false;
  clearTimeout(longPressTimer);
  longPressTimer = setTimeout(() => {
    if (!swipeState || swipeState.locked || swipeState.cancelled) return;
    longPressFired = true;
    // Open the properties / actions sheet for this node.
    openNode(nodeId);
    try { navigator.vibrate?.(15); } catch (e) {}
  }, LONG_PRESS_MS);
}

export function handleSwipeMove(event) {
  if (!swipeState || event.touches.length !== 1) return;
  const touch = event.touches[0];
  const dx = touch.clientX - swipeState.startX;
  const dy = touch.clientY - swipeState.startY;
  if (Math.abs(dx) > LONG_PRESS_MOVE_THRESHOLD || Math.abs(dy) > LONG_PRESS_MOVE_THRESHOLD) {
    clearTimeout(longPressTimer);
    longPressTimer = null;
  }
  if (!swipeState.locked) {
    if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
      swipeState.cancelled = true;
      return;
    }
    if (Math.abs(dx) > 10) {
      swipeState.locked = true;
    } else {
      return;
    }
  }
  if (swipeState.cancelled || !swipeState.swipeAllowed) return;
  // Only respond to leftward swipe.
  if (dx > 0) {
    swipeState.deltaX = 0;
    swipeState.row.style.transform = "";
    swipeState.row.classList.remove("mobile-swiping");
    return;
  }
  event.preventDefault();
  const offset = Math.max(dx, -SWIPE_MAX_OFFSET);
  swipeState.deltaX = offset;
  swipeState.row.classList.add("mobile-swiping");
  swipeState.row.style.transform = `translateX(${offset}px)`;
}

export function handleSwipeEnd(event) {
  clearTimeout(longPressTimer);
  longPressTimer = null;
  if (!swipeState) return;
  const { row, deltaX, nodeId, cancelled, swipeAllowed } = swipeState;
  row.style.transform = "";
  row.classList.remove("mobile-swiping");
  swipeState = null;
  if (longPressFired) {
    // Suppress the synthetic click that would otherwise fire after a long-press.
    event?.preventDefault?.();
    setSuppressNextRowClick(true);
    return;
  }
  if (cancelled || !swipeAllowed) return;
  if (deltaX <= -SWIPE_DELETE_THRESHOLD) {
    requestDeleteNode(nodeId);
  }
}

export function handleSwipeCancel() {
  clearTimeout(longPressTimer);
  longPressTimer = null;
  if (!swipeState) return;
  swipeState.row.style.transform = "";
  swipeState.row.classList.remove("mobile-swiping");
  swipeState = null;
}

export function resetOutlineTouch() {
  clearTimeout(longPressTimer);
  longPressTimer = null;
  swipeState = null;
  longPressFired = false;
}
